import * as React from "react";
const HourGlass = (props) => (
  <svg
    width={33}
    height={33}
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.13265 3.75049V7.65049C9.13265 11.9583 12.6024 15.4505 16.8826 15.4505C21.1629 15.4505 24.6326 11.9583 24.6326 7.65049V3.75049H27.216V7.65049C27.216 11.5661 25.0659 14.9763 21.8892 16.7505C25.0659 18.5246 27.216 21.9349 27.216 25.8505V29.7505L6.54932 29.7505V25.8505C6.54932 21.9349 8.69939 18.5246 11.8761 16.7505C8.69939 14.9763 6.54932 11.5661 6.54932 7.65049V3.75049H9.13265Z"
      fill="#792C76"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.88263 2.08398H28.8826V4.75065H4.88263V2.08398ZM4.88263 28.7506H28.8826V31.4173H4.88263V28.7506Z"
      fill="#792C76"
    />
  </svg>
);
export default HourGlass;
